import { Box, Circle, Flex, Text } from '@chakra-ui/react';
import { FaWallet } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../../app/constants';
import dayjs from 'dayjs';

const EstateDueCard = ({ estateDue, estateDues }) => {
  // console.log(estateDues);
  const { MY_WALLET } = PROTECTED_PATHS;
  return (
    <Box py='5'>
      <Box shadow='sm' bg='gray.300' p={['4', '5']} borderRadius='10px'>
        <Flex justify='space-between' align='center'>
          <Text color='primary' fontWeight='600' fontSize='15px'>
            Estate Due
          </Text>
          <Circle border='1px solid #EFE2FF' padding='8px'>
            <Link to={MY_WALLET}>
              <FaWallet color='#FC7067' cursor='pointer' />
            </Link>
          </Circle>
        </Flex>
        <Flex {...rowStyles}>
          <Text>Estate due date</Text>
          <Text fontSize='14px'>
            {dayjs(estateDues?.[0]?.endDate).format('DD-MM-YYYY')}
          </Text>
        </Flex>
        <Flex {...rowStyles}>
          <Text>Estate due/Month</Text>
          <Text fontSize='14px'>&#8358; {estateDue?.estateDue}</Text>
        </Flex>
      </Box>
    </Box>
  );
};

export default EstateDueCard;

const rowStyles = {
  justify: 'space-between',
  align: 'center',
  bg: '#FFFFFF',
  p: '4px 10px',
  mt: '10px',
  color: '#4A1977',
  fontSize: '12px',
};
